import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  pageWrap: {
    display: "flex",
    width: "100%",
    height: "88vh",
    backgroundColor: theme.colors.paper,
  },
  menu: {
    width: 250,
    overflowY: "auto",
    borderRight: `2px solid ${theme.colors.grey1}`,
  },
  content: {
    flex: 1,

    overflowY: "auto",
  },
}));

function SettingsPage(props) {
  const classes = useStyles();

  return (
    <div className={classes.pageWrap}>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
}

export default SettingsPage;
